import React from 'react';
import {ISearchResultItem} from '../../search-result/search-result-item.interface';
import {SdmGame} from '../../../sdm/sdm-game';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import Grid from '@material-ui/core/Grid/Grid';
import IconButton from '@material-ui/core/IconButton';


export class FoundSdmGame implements ISearchResultItem {
    constructor(private gameInfo: SdmGame, private services: ILauncherServiceFactory) {

    }

    private _handleClick = () => {
        this.services.gamesCustomization.addSdmGame(this.gameInfo.gameType);
    };


    get key(): any {
        return this.gameInfo.gameType;
    }

    private _renderAddButton() {
        if(this.services.gamesCustomization.isGameInCustomizationList(this.gameInfo.gameType)) {
            return null;
        }

        return (
            <IconButton color="primary" size="small" onClick={this._handleClick} >
                <AddIcon fontSize="inherit" />
            </IconButton>
        );
    }

    render() {
        return (
            <Grid container spacing={0} alignItems='center'>
                <Grid item xs={11}>
                    <Typography component='h6' gutterBottom>{this.gameInfo.gameType} - {this.gameInfo.title}</Typography>
                    <Typography variant='caption' gutterBottom>{this.gameInfo.combineVendorAndCompanyName()}</Typography>
                </Grid>
                <Grid item xs>
                    {this._renderAddButton()}
                </Grid>

            </Grid>
        );
    }
}